import { ComboDataDTO } from '../../../dto/ComboDataDTO';

export interface AgendaAppointment {
  medicalscheduletemplate: number | null;
  patientcarequeue: number | null;
  medereentity: number | null;
  outofschedule: boolean;
  appointmentstate: string;
  appointmentstateid: number | null;
  appointmentstatecategoryid: number | null;
  appointmentpriority: string;
  appointmentprioritycolor: string;
  patientname: string;
  queuetype: number;
  appointmentdate: string | null;
  scheduleactivity: string;
  professional: string;
  evolutionprofessional: string;
  medicalspeciality: string;
  locationsname: string;
  evolution: boolean | null;
  laststatus: string | null;
  appointmentsgroup: number | null;
  arrivaltime: string | null;
  servedtime: string | null;
  completedtime: string | null;
  medicalschedulesetup: number | null;
  scheduleactivitytype: number | null;
  patientappointmentpriority: number | null;
  reasonconsultation: string;
  filterdate: string | null;
  healthentity: number | null;
  healthentityname: string;
  notes: string;
  description: string;
  document: string;
  documenttype: number | null;
  docshortname: string;
  planname: string;
  businessname: string;
  benefitnumber: string;
  voluntary: boolean;
  clinichistoryid: string;
  appointmentdatetime: string | null;
  professionalmedereentity: number | null;
  medicalspecialityid: number | null;
  doctorsofficeactivity: string;
  videocall: boolean | null;
  videocallsetup: boolean | null;
  facetofacesetup: boolean | null;
  email: string;
  mobilephone: string;
  phonenumber: string;
  address: string;
  patientcontroldate: string | null;
  multipleevolutions: boolean;
  site: number | null;
  appointmentfromtime: string;
  appointmenttotime: string;
  date: string | null;
  commercialname: string;
  name: string;
  servicedate: string | null;
  changeappstate: string;
  hasbenefitorder: boolean;
  outofagenda: boolean;
}

export interface AgendaStats {
  waiting: number;
  inAttention: number;
  completed: number;
  missed: number;
  totalAppointments: number;
  totalSlots: number;
  overturnCount?: number;
}

// ─── Monthly calendar summary types ─────────
export interface DailySummaryDTO {
  date: string;
  occupied: number;
  free: number;
  isExclusion: boolean;
}

export interface MonthlyTotals {
  scheduled: number;
  free: number;
  exclusionDays: number;
  totalSlots: number;
}

export interface MonthlyCalendarResponse {
  days: DailySummaryDTO[];
  totals: MonthlyTotals;
}

export interface AgendaProfessional {
  id: number;
  name: string;
}

export interface AgendaSpeciality {
  id: number;
  name: string;
}

export interface AgendaBuilding {
  id: number;
  name: string;
  address?: string | null;
}

export type AgendaViewMode = 'professional' | 'service';

export interface AgendaSchedule {
  templateIds: number[];
  name: string;
  professionalId: number;
  professionalName: string;
  speciality: string | null;
  specialityIds: number[];
  agendaType: AgendaViewMode;
  attentionDuration?: number | null;
  fromHour?: string | null;
  toHour?: string | null;
}

export interface PatientSearchResult {
  id: number;
  fullName: string;
  document: string;
  documentType: string;
  email: string | null;
  mobilePhone: string | null;
  phoneNumber: string | null;
  birthDate: string | null;
  benefitNumber: string | null;
  coverageName: string | null;
  planName: string | null;
  voluntary: boolean | null;
}

export interface BookAppointmentRequest {
  // Identified patient
  patientId?: number;
  // Unidentified patient
  patientReference?: string;
  patientPhone?: string;
  patientDocument?: string;
  healthEntityPlanId?: number | null;
  benefitNumber?: string;
  // Common
  buildingId?: number | null;
  scheduleSetupId: number | null;
  appointmentDateTime: string;
  duration: number;
  professionalId?: number | null;
  specialityId?: number | null;
  notes?: string;
  reason?: string;
  priorityId?: number | null;
  practices?: {
    nomenclatorId: number;
    requestingDoctorId: number | null;
    practiceDate: string | null;
    observations: string;
  }[];
  // Notification preferences
  notifyWhatsApp?: boolean;
  notifyEmail?: boolean;
  // Overturn flag
  outOfSchedule?: boolean;
  // Appointment registered outside the professional's generated slots
  outOfAgenda?: boolean;
}

export interface ComboOption {
  id: number;
  name: string;
}

export interface BookAppointmentResponse {
  appointmentId: number;
  state: number;
}

export interface PatientAppointmentWarning {
  appointmentId: number;
  appointmentDateTime: string;
  stateId: number;
  stateLabel: string;
}

export interface PaginatedResponse<T> {
  data: T[];
  totalCount: number;
  offset: number;
  pageSize: number;
}

export enum PatientCheckInStatus {
  COMPLETE = 1,
  INCOMPLETE = 2,
  UNIDENTIFIED = 3,
}

export interface PatientStatusResponse {
  statusId: number;
  onlyImages: boolean;
  patientData: {
    medereentity?: number;
    firstname?: string;
    lastname?: string;
    document?: string;
    gender?: string;
    birthdate?: string;
    mobilephone?: string;
    email?: string;
    hasCoverage?: boolean;
    insurances?: any[];
    // From provisional contact
    referenceName?: string;
    phone?: string;
    healthEntityPlanId?: number;
    healthEntityPlanName?: string;
    healthEntityId?: number;
    healthEntityName?: string;
    benefitNumber?: string;
  };
}

export interface AppointmentPractice {
  id?: number;
  nomenclatorId: number;
  code: string;
  description: string;
  requestingDoctorId: number | null;
  requestingDoctorName: string | null;
  practiceDate: string | null;
  observations: string;
}

export enum EAgendaTab {
  LIST = 1,
  SCHEDULE = 2,
}

export enum EAgendaLens {
  DAY = 1,
  WEEK = 2,
  MONTH = 3,
}

export enum EWeekBlockStatus {
  SCHEDULED = 1,
  CONFIRMED = 2,
  WAITING = 3,
  IN_ATTENTION = 4,
  COMPLETED = 5,
  MISSED = 6,
  EXCLUSION = 7,
  FREE = 8,
}

export interface WeekStats {
  totalAppointments: number;
  occupied: number;
  free: number;
  overturnCount: number;
}

export interface MonthStats {
  scheduled: number;
  free: number;
  exclusionDays: number;
  totalSlots: number;
}

export interface WeekDayHeader {
  dayName: string;
  dayNumber: number;
  isToday: boolean;
}

export interface WeekBlock {
  dayIndex: number;
  topPx: number;
  heightPx: number;
  label: string;
  sublabel?: string;
  status: EWeekBlockStatus;
  appointmentId?: number;
}

export interface MonthDayCell {
  date: Date;
  dayNumber: number;
  isCurrentMonth: boolean;
  isToday: boolean;
  isExclusion: boolean;
  occupied: number;
  free: number;
}

export interface MultiDayAppointmentRow {
  dayLabel: string;
  date: string;
  time: string;
  patientName: string;
  statusLabel: string;
  /** Estado del turno: define el tag (ver getStatusInfo) */
  stateId: number | null;
  professional: string;
  appointmentId?: number;
}

// ─── Change location types ──────────────────────────

export interface ScheduleTagDTO {
  id: number;
  name: string;
}

export interface ScheduleSetup {
  setupId: number;
  professional: string;
  description: string;
  activityType: string;
  location: string;
  appointments: number;
}

export interface ChangeLocationRequest {
  locationId: number;
  setupIds: number[];
}

// ─── Appointment log types ───────────────────────────

export interface AppointmentLogEntryDTO {
  changeDate: string;
  userName: string;
  fullName: string;
  stateName: string;
  actionDescription: string;
  notes: Record<string, string> | null;
}

// ─── Priority types ─────────────────────────────────

export interface PriorityDTO {
  id: number;
  description: string;
  color: string;
  priorityOrder: number;
}

// Los tipos del cobro del turno están en billing.types.ts

